import routes from 'routes'

const sidebarGroups = [
  { name: 'Events & Venues', items: ['Events', 'Venues', 'Seating Plans', 'Waitlist'] },
  { name: 'Ticket Operations', items: ['Tickets', 'Gate Check-In'] },
  { name: 'Finance & Reports', items: ['Payment Gateways', 'Vouchers', 'Cancellations', 'Reconciliation', 'Reports & Analytics'] },
  { name: 'Content', items: ['Carousel', 'Event Highlights', 'Videos', 'Gallery', 'Blog Posts', 'Sponsors', 'About Us'] },
  { name: 'Audience', items: ['Users', 'Communities', 'Feedbacks', 'Subscribers'] },
  { name: 'System', items: ['Settings'] },
]

const sidebarRoutes = sidebarGroups.map(group => ({
  name: group.name,
  category: true,
  items: routes.filter(route => group.items.includes(route.name)),
}))

export default sidebarRoutes
